var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_26080)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.9375C4.5472 0.9375 0.9375 4.5472 0.9375 9C0.9375 13.4528 4.5472 17.0625 9 17.0625C13.4528 17.0625 17.0625 13.4528 17.0625 9C17.0625 4.5472 13.4528 0.9375 9 0.9375ZM8.99373 4.6875C7.64682 4.6875 6.55356 5.77805 6.55356 7.125C6.55356 8.47195 7.64682 9.5625 8.99373 9.5625C10.3406 9.5625 11.4339 8.47195 11.4339 7.125C11.4339 5.77805 10.3406 4.6875 8.99373 4.6875ZM12.7807 12.3601C10.7801 10.2001 7.18104 10.3115 5.22286 12.3567L5.08223 12.4974C4.97328 12.6063 4.91379 12.7552 4.91766 12.9092C4.92153 13.0633 4.98841 13.209 5.1027 13.3123C6.13327 14.2442 7.50097 14.8125 9.00008 14.8125C10.4992 14.8125 11.8669 14.2442 12.8975 13.3123C13.0118 13.209 13.0786 13.0633 13.0825 12.9092C13.0864 12.7552 13.0269 12.6063 12.9179 12.4974L12.7807 12.3601Z",
    fill: "#141B34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_26080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ff641968b8c43ca983c521ab36a5ba41.svg";
export { ForwardRef as ReactComponent };